import { useState } from 'react';
import { useTranslation } from '../../i18n';
import { MAX_HEADLINE_GOOGLE, MAX_DESCRIPTION_GOOGLE } from '../../lib/constants';

const CAMPAIGN_TYPES = ['googleSearch', 'googleDisplay', 'metaFeed', 'metaStory', 'seo'];
const TABS = ['googleAds', 'metaAds', 'keywords', 'seo'];

// TODO(api): replace with GET /api/v1/events?status=confirmed.
const MOCK_EVENTS = [
  { id: 'e1', label: 'Heritage Summit Kraków · 12 Jun 2026' },
  { id: 'e2', label: 'Youth Workshop Warsaw · 20 Sep 2026' },
];

// TODO(api): replace with POST /api/v1/campaigns response.
const MOCK_HEADLINES = [
  { pl: 'Dziedzictwo wymaga ochrony',    en: 'Heritage needs protection' },
  { pl: 'Wesprzyj F8M dziś',              en: 'Support F8M today' },
  { pl: 'Cyfrowe Dziedzictwo Polski',    en: 'Polish digital heritage' },
];

const MOCK_DESCRIPTIONS = [
  { pl: 'Dołącz do F8M w ochronie polskiego dziedzictwa kulturowego. Każda darowizna trafia do konkretnych projektów.',
    en: 'Join F8M in protecting Polish cultural heritage. Every donation funds specific projects.' },
  { pl: 'Cyfrowo zachowane dziedzictwo dla przyszłych pokoleń. Sprawdź, jak możesz pomóc.',
    en: 'Digitally preserved heritage for future generations. See how you can help.' },
];

export function CampaignPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState('googleAds');
  const [prompt, setPrompt] = useState('');
  const [campaignType, setCampaignType] = useState('googleSearch');
  const [eventId, setEventId] = useState('');

  return (
    <div>
      <header className="page-header">
        <h1 className="page-header__title">{t('campaigns.title')}</h1>
        <div className="page-header__subtitle">{t('campaigns.subtitle')}</div>
      </header>

      <div className="campaign-split">
        <form className="campaign-form" onSubmit={(e) => e.preventDefault()}>
          <label className="form-field">
            <span className="form-field__label">{t('campaigns.promptLabel')}</span>
            <textarea
              className="form-field__textarea"
              value={prompt}
              placeholder={t('campaigns.promptPlaceholder')}
              onChange={(e) => setPrompt(e.target.value)}
              rows={5}
            />
          </label>

          <label className="form-field">
            <span className="form-field__label">{t('campaigns.typeLabel')}</span>
            <select
              className="form-field__select"
              value={campaignType}
              onChange={(e) => setCampaignType(e.target.value)}
            >
              {CAMPAIGN_TYPES.map((type) => (
                <option key={type} value={type}>{t(`campaigns.types.${type}`)}</option>
              ))}
            </select>
          </label>

          <label className="form-field">
            <span className="form-field__label">{t('campaigns.eventLink')}</span>
            <select
              className="form-field__select"
              value={eventId}
              onChange={(e) => setEventId(e.target.value)}
            >
              <option value="">{t('campaigns.eventPlaceholder')}</option>
              {MOCK_EVENTS.map((ev) => (
                <option key={ev.id} value={ev.id}>{ev.label}</option>
              ))}
            </select>
          </label>

          <button type="button" className="button button--primary" disabled={!prompt.trim()}>
            ✨ {t('campaigns.generate')}
          </button>
        </form>

        <div className="campaign-results">
          <div className="tabs" role="tablist">
            {TABS.map((key) => (
              <button
                key={key}
                type="button"
                role="tab"
                aria-selected={tab === key}
                className={'tab' + (tab === key ? ' tab--active' : '')}
                onClick={() => setTab(key)}
              >
                {t(`campaigns.tabs.${key}`)}
              </button>
            ))}
          </div>

          {tab === 'googleAds' && (
            <div className="campaign-results">
              <section className="section-card">
                <h3 className="section-card__title">{t('campaigns.googleAds.headlinesTitle')}</h3>
                <div className="headline-list">
                  {MOCK_HEADLINES.map((h, i) => (
                    <div key={i} className="headline-row">
                      <span>{h.pl}</span>
                      <span className={
                        'headline-row__count' +
                        (h.pl.length > MAX_HEADLINE_GOOGLE ? ' headline-row__count--over' : '')
                      }>
                        {h.pl.length}/{MAX_HEADLINE_GOOGLE}
                      </span>
                    </div>
                  ))}
                </div>
              </section>

              <section className="section-card">
                <h3 className="section-card__title">{t('campaigns.googleAds.descriptionsTitle')}</h3>
                <div className="headline-list">
                  {MOCK_DESCRIPTIONS.map((d, i) => (
                    <div key={i} className="headline-row">
                      <span>{d.pl}</span>
                      <span className={
                        'headline-row__count' +
                        (d.pl.length > MAX_DESCRIPTION_GOOGLE ? ' headline-row__count--over' : '')
                      }>
                        {d.pl.length}/{MAX_DESCRIPTION_GOOGLE}
                      </span>
                    </div>
                  ))}
                </div>
              </section>

              <section className="section-card">
                <h3 className="section-card__title">{t('campaigns.googleAds.previewTitle')}</h3>
                <div className="ad-preview">
                  <div className="ad-preview__label">{t('campaigns.googleAds.previewLabel')}</div>
                  <div className="ad-preview__url">{t('campaigns.googleAds.previewUrl')}</div>
                  <div className="ad-preview__title">{MOCK_HEADLINES[0].pl}</div>
                  <div className="ad-preview__desc">{MOCK_DESCRIPTIONS[0].pl}</div>
                </div>
              </section>
            </div>
          )}

          {tab !== 'googleAds' && (
            <div className="empty-state">
              <div className="empty-state__icon" aria-hidden="true">🚧</div>
              <p>{t('campaigns.comingSoon')}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
